import React, { Component } from "react";
import LayoutPage from "../LayoutIdentificationPages";
import NormalLoginForm from "./LoginForm";

class Login extends Component {
  componentDidMount() {
    localStorage.removeItem('token_auth');
    localStorage.removeItem('refresh_token');
  }

  render() {
    return (
      <LayoutPage title="Identification">
        <NormalLoginForm />
      </LayoutPage>
    );
  }
}

export default Login;
